type FormTemplate = { id: string; name: string; thumbnail: string; url: string };
export const FORM_TEMPLATES: FormTemplate[] = [
  {
    id: 'contact',
    name: 'Black & White',
    thumbnail: '/formThumbnails/Black&White.png',
    url: '/forms/form-1.html',
  },
  {
    id: 'contact-2',
    name: 'Moderna Corporate',
    thumbnail: '/formThumbnails/ModernCorporate.png',
    url: '/forms/form-2.html',
  },
  {
    id: 'contact-3',
    name: 'Pickled Onion Form',
    thumbnail: '/formThumbnails/PickledOnion.png',
    url: '/forms/form-3.html',
  },
  {
    id: 'contact-4',
    name: 'Black & Neon',
    thumbnail: '/formThumbnails/Black&Neon.png',
    url: '/forms/form-4.html',
  },
  {
    id: 'contact-5',
    name: 'Boho',
    thumbnail: '/formThumbnails/Boho.png',
    url: '/forms/form-5.html',
  },
  {
    id: 'contact-6',
    name: 'Vintage Pop',
    thumbnail: '/formThumbnails/VintagePop.png',
    url: '/forms/form-6.html',
  },
];

// ---------- Types ----------
type PageDef = { id: string; name: string; html: string };

// ---------- Constants ----------
export const TEMPLATES: PageDef[] = [{ id: 'home', name: 'Home', html: '/templates/template1.html' }];
